import { Link } from './Link.container';

export default Link;
